import React, { useState } from 'react';
import { Spin, Form, Select, Alert } from 'antd';
import { mastersQuery, useSubmit } from '../../../../api';
import BaseModal from '../../../BaseModal/BaseModal';
import FetchError from '../../../FetchError/FetchError';
import { fieldNames } from './constants';
import { useSetModalVisible } from '../../../../model/modalState';
import { dspxGetWorkerChildrens } from '../../../../../../../../helpers/dspx-utils';
import InformationBlockModal from '../../../InformationBlockModal/InformationBlockModal';
import { typeMassActionsText } from '../../../InformationBlockModal/constants';

const { useFetch: useMasters } = mastersQuery;
const { Item: FormItem, create: createForm } = Form;

const ErrorContent = ({ refetch }) => {
  return (
    <FetchError
      msg="Не удалось получить список мастеров"
      onClick={() => refetch()}
    />
  );
};

const FormContainer = ({form, requests, onSuccess }) => {
  const { getFieldDecorator, validateFields, resetFields } = form;

  const { data, isFetching, refetch } = useMasters({
    staleTime: Infinity,
    notifyOnChangeProps: ['data', 'isFetching'],
  });

  const { submitAsync, loading } = useSubmit({
    url: '/Request/set_master',
    errMsg: 'Не удалось изменить мастера у выбранных заявок',
    onSuccess,
  });

  const isError = data === 'Error';

  const setModalVisible = useSetModalVisible();
  const [stateInfo, setStateInfo] = useState(false);
  const [value, setValue] = useState(null)

  const handleSubmit = (e) => {
    e.preventDefault();

    validateFields((err, values) => {
      if (!err) {
        const value = {
          MasterId: values.master
      };

      setValue(value);
      setStateInfo(true);
      }
    });
  };

  const handleConfirmSubmit = async (e) => {
    e.preventDefault()

    try {
      await submitAsync({
        ids: requests.map(({ id }) => id),
        value,
        requests,
      });

      setModalVisible(false);
      setStateInfo(false);
      resetFields();
    } catch(error) {
      return <Alert title={error.message} />
    }
  }

  const cancelSubmit = () => {
    setStateInfo(false);
    resetFields()
  }

  return (
    <BaseModal
      title={stateInfo ? "Подтвердите изменения" : "Изменение мастера"}
      okButtonProps={{ disabled: isFetching }}
      footer={isError ? null : undefined}
      onOk={stateInfo ? handleConfirmSubmit : handleSubmit}
      onCancel={cancelSubmit}
      confirmLoading={loading}
      width={stateInfo ? 600 : 450}
    >
      <Spin spinning={Boolean(isFetching)}>
        {isError ? (
          <ErrorContent refetch={refetch} />
        ) : (
          !stateInfo ? (
          <Form>
            <FormItem label="Мастер">
              {getFieldDecorator(fieldNames.master, {
                rules: [
                  {
                    required: true,
                    message: 'Выберите мастера',
                  },
                ],
              })(
                <Select
                  showSearch
                  optionLabelProp="label"
                  optionFilterProp="searchtext"
                  placeholder="Выберите мастера"
                >
                  {dspxGetWorkerChildrens(data, undefined, true)}
                </Select>
              )}
            </FormItem>
          </Form>
        ) : (
          <InformationBlockModal typeMassActions={typeMassActionsText.master} count={requests.length} />
        )
        )}
      </Spin>
    </BaseModal>
  );
};

const ChangeMaster = createForm({ name: 'mass_actions_master' })(FormContainer);
export default ChangeMaster;
